<template>
  <bean-source-page :type="type" :columns="columns" :filter-columns="filterColumns" :form="form" :title="$t('model.user')"
    :actions="actions" resource="users" />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/users.js';

@Component
export default class Users extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    const array = [
      'email_cont',
      'screen_name_cont',
      'phone_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'email',
      'phone_country_code',
      'phone',
      'screen_name',
      'avatar',
      'is_block',
      'created_at',
      'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */

  actions({ row }, { remove, reload }) {
    return [
      row.is_block && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToFalse'),
          can: 'users.update',
          type: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/unblock`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      !row.is_block && {
        component: 'confirmButton',
        props: {
          label: this.$t('actions.user.isBlockToTrue'),
          can: 'users.update',
          ype: 'primary'
        },
        on: {
          confirm: async () => {
            await this.$autoLoading(this.$request.put(`/users/${row.id}/block`));
            this.$message.success(this.$t('operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'users.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      },
      {
        component: 'routeButton',
        props: {
          label: '常用乘客',
          to: { name: 'passengers.index', query: { user_id_eq: row.id } }
        }
      },
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/users',
    name: 'users.index',
    component: Users,
    props: {
      type: 'index',
    }
  },
  {
    path: '/users/new',
    name: 'users.new',
    component: Users,
    props: {
      type: 'new',
    }
  },
  {
    path: '/users/:id',
    name: 'users.show',
    component: Users,
    props: {
      type: 'show',
    }
  },
  {
    path: '/users/:id/edit',
    name: 'users.edit',
    component: Users,
    props: {
      type: 'edit'
    }
  }
]
</script>
